import { useState, useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { createMenuItems } from "../utils/staffTableHelpers"

export const useStaffTable = (t, onEdit, permissionChecker = null, userRole = null) => {
  const navigate = useNavigate()
  const [deactivateModalVisible, setDeactivateModalVisible] = useState(false)
  const [activateModalVisible, setActivateModalVisible] = useState(false)
  const [deleteModalVisible, setDeleteModalVisible] = useState(false)
  const [selectedStaff, setSelectedStaff] = useState(null)

  const handleView = useCallback(
    (staffId) => {
      navigate(`${staffId}`)
    },
    [navigate]
  )

  const handleEdit = useCallback(
    (staffId) => {
      if (onEdit) {
        onEdit(staffId)
      }
    },
    [onEdit]
  )

  const handleDeactivate = useCallback((staffMember) => {
    setSelectedStaff(staffMember)
    setDeactivateModalVisible(true)
  }, [])

  const handleActivate = useCallback((staffMember) => {
    setSelectedStaff(staffMember)
    setActivateModalVisible(true)
  }, [])

  const handleDelete = useCallback((staffMember) => {
    setSelectedStaff(staffMember)
    setDeleteModalVisible(true)
  }, [])

  const handleDeactivateConfirm = useCallback(
    (data) => {
      console.log("Deactivate staff confirmed:", selectedStaff?.id, data)
      setDeactivateModalVisible(false)
      setSelectedStaff(null)
    },
    [selectedStaff]
  )

  const handleActivateConfirm = useCallback(
    (data) => {
      console.log("Activate staff confirmed:", selectedStaff?.id, data)
      setActivateModalVisible(false)
      setSelectedStaff(null)
    },
    [selectedStaff]
  )

  const handleDeleteConfirm = useCallback(
    (data) => {
      console.log("Delete staff confirmed:", selectedStaff?.id, data)
      setDeleteModalVisible(false)
      setSelectedStaff(null)
    },
    [selectedStaff]
  )

  const handleModalCancel = useCallback(() => {
    setDeactivateModalVisible(false)
    setActivateModalVisible(false)
    setDeleteModalVisible(false)
    setSelectedStaff(null)
  }, [])

  const getMenuItems = useCallback(
    (staffMember) => {
      const handlers = {
        onView: handleView,
        onEdit: handleEdit,
        onDeactivate: handleDeactivate,
        onActivate: handleActivate,
        onDelete: handleDelete
      }
      return createMenuItems(staffMember, handlers, t, permissionChecker, userRole)
    },
    [t, handleView, handleEdit, handleDeactivate, handleActivate, handleDelete, permissionChecker, userRole]
  )

  return {
    deactivateModalVisible,
    activateModalVisible,
    deleteModalVisible,
    selectedStaff,
    getMenuItems,
    handleDeactivateConfirm,
    handleActivateConfirm,
    handleDeleteConfirm,
    handleModalCancel
  }
}
